/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      21 February 2024
 */

import VideoContainer from '../../Components/VideoContainer';

const DolceVita = () => {
  return (
    <div className='container max-w-[1920px] pt-8 sm:px-6 xl:px-10 mx-auto'>
      <VideoContainer video='https://www.youtube.com/embed/t60NM6VJCk8' />
      <div className='flex flex-col pt-10'>
        <div className='grid grid-cols-2 gap-2'>
          <img
            className='h-auto max-w-full'
            src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dolce/1_x5ydsq'
            alt=''
            loading='lazy'
          />
          <img
            className='h-auto max-w-full'
            src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dolce/2_qrwaac'
            alt=''
            loading='lazy'
          />
        </div>
        <img
          className='py-2'
          src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dolce/3_ae7py6'
          alt=''
          loading='lazy'
        />
        <div className='grid grid-cols-2 gap-2'>
          <img
            className='h-auto max-w-full'
            src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dolce/4_osy3v4'
            alt=''
            loading='lazy'
          />
          <img
            className='h-auto max-w-full'
            src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dolce/5_nersob'
            alt=''
            loading='lazy'
          />
        </div>
        <img
          src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dolce/6_kjixqo'
          alt=''
          loading='lazy'
        />
        <img
          className='py-2'
          src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/dolce/7_xdxi0f'
          alt=''
          loading='lazy'
        />
      </div>
    </div>
  );
};
export default DolceVita;
